import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Inside as Desc } from './desk'
import { Inside as Mob } from './mob'

type Props = {
  images: TImages
}
export const Inside: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
